<template>
  <div class="subscription">
    <div class="subscription-container">
      <p class="subscription-title">{{ $t('select_email_preferences') }}:</p>
      <el-radio-group class="radio-container" v-model="subValue" @change="subChange">
        <el-radio class="radio-single" :label="true">
          <div class="radio-big">{{ $t('stay_up_todate') }}</div>
          <div class="radio-small">{{ $t('subscribe_newsletter') }}</div>
        </el-radio>
        <el-radio class="radio-single" :label="false">
          <div class="radio-big">{{ $t('unsubscribe_emails') }}</div>
          <div class="radio-small">{{ $t('we_miss_you') }}</div>
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>


<script>
import {mapActions, mapState, mapMutations} from "vuex";
// import Router from "../router";
// import { isUserAuthenticated } from "../store/modules/cart";
export default {
  name: "Subscription",
  data() {
    return {
      subValue: null,

    };
  },
  methods: {
    ...mapActions('profile', ['fetchSubscribeEmail', 'postSubscribeEmail', 'putUnsubscribeEmail']),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    subChange() {
      if (this.subValue === true) {
        this.postSubscribeEmail(this.userDetails.email);
      } else {
        this.putUnsubscribeEmail(this.userDetails.email);
      }
    }
  },
//   beforeRouteLeave(to, from, next) {
//     next();
//   },
  mounted() {
    this.fetchSubscribeEmail(this.userDetails.email)
      .then(res => {
        this.subValue = true;
      }).catch(err => {
      this.subValue = false;
    });
  },
  watch: {
    $route(to, from) {

    },
    // userDetails: function(newVal, oldVal) {
    // },
  },
  computed: mapState({
    userDetails: state => state.auth.userDetails,
  }),
};

</script>
​
<style scoped lang="less">
@import "../../assets/css/public";
@import "../../assets/css/emailSubscription";
</style>



// WEBPACK FOOTER //
// src/view/Profile/emailSubscription.vue